export default "__VITE_ASSET__BM9q7GVy__"